import { useTranslation } from 'react-i18next';
import { LOCALES, type Locale, NATIVE_NAME, REGION_TAG } from './config';
import { setLocale } from './index';
import { setLocalePreference } from '@/services/me';

/** Seletor nativo (<select>): acessível por teclado/leitor de ecrã sem JS extra e sem overflow em mobile. */
export function LanguageSwitcher({ compact = false }: { compact?: boolean }) {
  const { t, i18n } = useTranslation();
  const current = i18n.language as Locale;

  const change = async (next: Locale) => {
    await setLocale(next);                              // UI muda já, sem reload
    void setLocalePreference(next).catch(() => {});     // viaja com a conta (anónimo: ignora)
  };

  return (
    <label className="lang-switch" style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
      <span className={compact ? 'sr-only' : undefined} style={{ fontSize: 'var(--fs-sm)', color: 'var(--fg-60)' }}>
        {t('language.label')}
      </span>
      <select
        value={current}
        onChange={(e) => void change(e.target.value as Locale)}
        aria-label={t('language.choose')}
        style={{ minHeight: compact ? 40 : 44, maxWidth: compact ? 112 : undefined, borderRadius: 12, padding: compact ? '0 6px' : '0 12px', background: 'var(--bg-2)', color: 'inherit', border: '1px solid var(--border-1, transparent)', fontSize: compact ? 14 : 16 }}
      >
        {LOCALES.map((l) => (
          <option key={l} value={l} lang={REGION_TAG[l]}>{NATIVE_NAME[l]}</option>
        ))}
      </select>
    </label>
  );
}
